import React, { useEffect, useState } from 'react';
import BaseModel from '../../BaseModal'
import { LineView } from '../../styles/WrapperStyles'
import styled from 'styled-components';
import { authorizedHttpGet } from '../../api/httpCalls';
import Loader from '../Loader';

const ParentDiv = styled.div`
  width: 445px;
  height: 239px;
  border-radius: 20px;
`;

const TextView = styled.p`
  font-family: 'Gilory-Semi';
  font-size: 20px;
  font-weight: 800;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #484848;
  text-align: center;
  cursor: pointer;
`;

function StoryListModal(props) {

    const createParams = (note, reason_id) => {
        let has_note = "0"
        if (note.includes('+ Note')) {
            has_note = "1"
        } else if (note === 'All') {
            has_note = "0"
            reason_id = null
        }
        let params = {
            has_note: has_note,
            reason_id: reason_id,
            story: note
        }
        props.updateStory(params)
    }

    return (
        <BaseModel closeModal={props.closeModal}>
            <ParentDiv>
                {props.dropDownOptions.map((story) => (
                    <div key={story} onClick={() => createParams(story['name'], story['id'])}>
                        <TextView>{story['name']}</TextView>
                        <LineView />
                    </div>
                ))}
            </ParentDiv>
        </BaseModel>
    );
}

export default StoryListModal;
